<article class="ul-card narrow">
  <comp-card-header>
    <span headline>{{ 'general.about' | translate }}</span>
  </comp-card-header>
  <h2>{{ 'about.fossComponents' | translate }}</h2>
  @if (fossInfo$ | async; as fossInfo) {
    <ul>
      @for (component of fossInfo; track component.name) {
        <li>
          <p>
            <a
              class="external-link"
              target="_blank"
              rel="noopener noreferrer"
              href="{{ component.link }}"
              >{{ component.name }}</a
            >
            {{ component.version }}
            @if (component.copyrightEntity) {
              by {{ component.copyrightEntity }}
            }
          </p>
          @if (component.licenseText) {
            <pre>
            {{ component.licenseText }}
            </pre>
          } @else if (component.licenseUrl) {
            <p>
              <a
                class="external-link"
                target="_blank"
                rel="noopener noreferrer"
                href="{{ component.licenseUrl }}"
                >{{ component.licenseUrl }}</a
              >
            </p>
          }
        </li>
      }
    </ul>
  } @else {
    <mat-spinner></mat-spinner>
  }
</article>
